module.exports = __webpack_public_path__ + "static/primer-small-button-26745fcb18dc8c9bf3bac191e0d94530.png";